import { render } from "./MessageCondensed.vue?vue&type=template&id=6431c4ac&ts=true"
import script from "./MessageCondensed.vue?vue&type=script&lang=ts"
export * from "./MessageCondensed.vue?vue&type=script&lang=ts"

import exportComponent from "/home/webchat/thelounge-lfnet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__